/** `snippets/search-panel.liquid` — `<search-panel>`: mirrors the `search-open` body class into open/aria/inert attributes. */

const SEARCH_BODY_CLASS = 'search-open'

class SearchPanel extends HTMLElement {
  #observer

  connectedCallback() {
    this.#sync()

    this.#observer = new MutationObserver(() => this.#sync())
    this.#observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
  }

  disconnectedCallback() {
    this.#observer?.disconnect()
    this.#observer = null
  }

  #sync() {
    const isOpen = document.body.classList.contains(SEARCH_BODY_CLASS)
    this.toggleAttribute('open', isOpen)
    this.setAttribute('aria-hidden', isOpen ? 'false' : 'true')
    if (isOpen) {
      this.removeAttribute('inert')
    } else {
      this.setAttribute('inert', '')
    }
  }
}

if (!customElements.get('search-panel')) {
  customElements.define('search-panel', SearchPanel)
}
